import React from 'react';
import { Box } from '@mui/material';

import DataSection from '../DataSection';
import AnalyticsChartPanel from './AnalyticsChartPanel';
import AnalyticsEmptyState from './AnalyticsEmptyState';
import AnalyticsTablePanel from './AnalyticsTablePanel';

const DEFAULT_SINGLE_CHART_MIN_HEIGHT = { xs: 300, sm: 320, md: 300 };
const DEFAULT_SINGLE_TABLE_MIN_HEIGHT = { xs: 260, sm: 280, md: 240 };

function WorkspaceSinglePanelView({
  panel = {},
  kind = panel.kind || 'table',
  children,
}) {
  const Panel = kind === 'chart' ? AnalyticsChartPanel : AnalyticsTablePanel;
  const defaultMinHeight = kind === 'chart'
    ? DEFAULT_SINGLE_CHART_MIN_HEIGHT
    : DEFAULT_SINGLE_TABLE_MIN_HEIGHT;

  return (
    <DataSection
      isLoading={panel.isLoading}
      skeletonSpec={panel.skeletonSpec}
      skeletonType={panel.skeletonType || kind}
      minHeight={panel.minHeight || defaultMinHeight}
      fadeDelay={panel.fadeDelay || 100}
    >
      <Box
        sx={[
          {
            width: '100%',
            minHeight: 0,
            height: { xs: 'auto', md: panel.fill === false ? 'auto' : '100%' },
            maxHeight: { xs: 'none', md: panel.fill === false ? 'none' : '100%' },
            overflow: { xs: 'visible', md: panel.fill === false ? 'visible' : 'hidden' },
          },
          panel.outerSx,
        ]}
      >
        <Panel
          title={panel.title}
          description={panel.description}
          actions={panel.actions}
          exportConfig={panel.exportConfig}
          exportEnabled={panel.exportEnabled ?? panel.hasData !== false}
          width={panel.width || '100%'}
          maxWidth={panel.maxWidth || '100%'}
          contentWidth={panel.contentWidth}
          contentMaxWidth={panel.contentMaxWidth}
          contentAlign={panel.contentAlign}
          headerLayout={panel.headerLayout}
          fill={panel.fill ?? true}
          allowAxisOverflow={panel.allowAxisOverflow}
          minFrameHeight={panel.minFrameHeight || defaultMinHeight}
          contentSx={panel.contentSx}
          sx={panel.sx}
        >
          {panel.hasData === false ? (
            <AnalyticsEmptyState
              icon={panel.emptyIcon}
              title={panel.emptyTitle}
              description={panel.emptyDescription}
            />
          ) : children}
        </Panel>
      </Box>
    </DataSection>
  );
}

export default WorkspaceSinglePanelView;
